/// <amd-module name="VSSUI/Components/TooltipHost/TooltipHost" />

import * as React from "react";
import { css } from "VSSUI/Util";
import { TooltipHost as OfTooltipHost, ITooltipHostProps } from "OfficeFabric/Tooltip";

/** @deprecated */
export class TooltipHost extends React.Component<ITooltipHostProps> {
    public render() {
        const realProps: ITooltipHostProps = { ...this.props };

        if (!realProps.calloutProps) {
            realProps.calloutProps = {
                isBeakVisible: false
            };
        }

        if (!realProps.calloutProps.gapSpace) {
            realProps.calloutProps.gapSpace = 8;
        }

        return <OfTooltipHost {...realProps} className={css(realProps.className || realProps.calloutProps.className, "vss-Tooltip")} />;
    }
}
